<template>
    <li>
        <a v-bind:href="item.Url.replace('~/','/')" v-bind:title="item.Title">
            <div class="person-listing-image">
                <img v-if="item.Image != ''" v-bind:src="item.Image" v-bind:alt="item.Title">
                <img v-if="item.Image == ''" src="/Content/images/person-avatar.png" v-bind:alt="item.Title">
            </div>
            <div class="person-listing-text">
                <p class="person-name">{{item.Title}}</p>
                <span class="person-title"></span>
                <p v-if="item.ProjectTitle != ''"><em>{{item.ProjectTitle}}</em></p>
            </div>
        </a>
    </li>
</template>

<script>
export default {
    props: ['item'],
}

$(document).ready(function() {
    $('#form-ResearchTopic').append($('<optgroup>', {
    label: ''
    }));
    $('#form-ResearchGrant').append($('<optgroup>', {
    label: ''
    }));
});
</script>